import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
}

export default {
  'customerCode': {
    title: '订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户编号'
    }
  },
  'customerName': {
    title: '订单客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'customerType': {
    title: '订单客户类型',
    describe: true,
    suffix:'TextView',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'saleCenter': {
    describe: true,
    suffix:'TextView',
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'saleAreaName': {
    title: '合同区域',
    width: 250,
  },
  'saleChannel': {
    title: '合同渠道',
  },
  'brand': {
    describe: true,
    suffix:'TextView',
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 200
  },
  'newPlanType': {
    title: '新计划类型',
    describe: true,
    suffix:'TextView',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 200,
  },
  // 'planType': {
  //   title: '旧计划类型',
  //   describe: true,
  //   suffix:'TextView',
  //   equation: city,
  //   dictionary: 'A0002',
  //   width: 250,
  // },
  'oldPlanType': {
    title: '渠道类型',
    slot: true,
    width: 200,
  },
  // 'histPlanQty': {
  //   title: '历史计划量',
  // },
  // 'billQty': {
  //   title: '开票数量',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'planQty21': {
  //   title: '2021年计划量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'billQty21': {
  //   title: '2021年开票数量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'planQty22': {
  //   title: '2022年计划量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'billQty22': {
  //   title: '2022年开票数量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'planQty23': {
  //   title: '2023年计划量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'billQty23': {
  //   title: '2023年开票数量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'deliverQty21': {
  //   title: '2021年发货数量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'deliverQty22': {
  //   title: '2022年发货数量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'deliverQty23': {
  //   title: '2023年发货数量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'selledQty21': {
  //   title: '2021年动销量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'selledQty22': {
  //   title: '2022年动销量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'selledQty23': {
  //   title: '2023年动销量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'breakRuleQty': {
  //   title: '2023年违规数量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'omitQty': {
  //   title: '遗留扣减量',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'selledStock': {
  //   title: '库存',
  //   width: 100,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  'signedQty': {
    title: '签约量',
    width: 120,
    xlsxFmt: {
      t: 'n'
    }
  },
  'signedDown': {
    title: '建议签约下限',
    width: 120,
    xlsxFmt: {
      t: 'n'
    }
  },
  'signedUp': {
    title: '建议签约上限',
    width: 120,
    xlsxFmt: {
      t: 'n'
    }
  },
  // 'scanCodeRate': {
  //   title: '跨大区扫码率',
  // },
}



// WEBPACK FOOTER //
// ./src/views/qy-manage/config/salePlanHistory.js